<template>
  <div class="logistics-list">
    <!-- 创建公司 -->
    <div class="resources-top">
      <div class="welcome">Hi，欢迎使用物流资源！</div>
      <div class="create-company">
        <div class="create-company-tips">
          <p class="title">快速创建物流公司</p>
          <p class="sub-title">从设置名称开始，创建并管理你的物流公司</p>
        </div>
        <div class="btn-content">
          <div class="mapping" @click="openMapping">
            <img class="precise-monitor" src="../../../../../assets/images/system/precise-monitor.png">
            <span>物流映射</span>
          </div>
          <el-button @click="createCompany" class="btn-blue" icon="el-icon-plus">创建公司</el-button>
        </div>
      </div>
    </div>

    <!-- 物流公司服务关系列表 -->
    <div class="logistics-main">
      <div class="left">
        <div class="search-company">
          <el-input
            v-model="searchCompanyName" 
            suffix-icon="el-icon-search" 
            placeholder="请输入物流公司名称"
            @keyup.enter.native="searchCompanyNameFnc"
          ></el-input>
        </div>
        <div
          class="company-row"
          :class="{'company-row-active': index == activeIndex}"
          v-for="(item, index) in logisticsCompanyList"
          :key="index"
          @click="selectLogistics(item, index)"
        >
          <div class="company-name">
            <div class="company-name-left">
              <img class="logistics" src="../../../../../assets/images/system/logistics.png">
              <p class="name">{{ item.name }}</p>
            </div>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <span class="more"></span>
              </span>
              <el-dropdown-menu slot="dropdown" class="mod-logistics">
                <el-dropdown-item :command="beforeHandleCommand(item, 'mod')">编辑</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="company-info">
            <div class="header">
              <span>负责人</span>
              <span>{{ item.header }}</span>
            </div>
            <div class="header">
              <span>手机号</span>
              <span>{{ item.phone }}</span>
            </div>
            <div class="express-type">
              <div class="express-type-title">快递类型</div>
              <div class="express-type-main">
                <div
                  v-for="(e, eIndex) in item.expressNameList"
                  :key="eIndex"
                  class="express-type-name"
                >
                  {{ e.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-top">
          <p class="right-top-title">服务关系</p>
          <div class="btn-container">
            <div class="add-warehouse" @click="addService">
              <span class="add-warehouse-img"></span>
              <span>新增</span>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="table" v-if="tableData.length">
            <el-table :data="tableData" style="width: 100%" :header-cell-class-name="serverHeaderCellClassName">
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                show-overflow-tooltip
                :min-width="item.width"
                :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
              >
                <template slot-scope="scope">
                  <div v-if="item.label === '成本系数' && scope.row.type == 2">
                    <el-input 
                      class="w60"
                      v-model="scope.row.costCoefficient" 
                      @input="inputTableCostCoefficient(scope.row.costCoefficient, scope.row)"
                      @blur="blurCostCoefficient(scope.row)"
                    >
                    </el-input>
                  </div>
                  <div v-else>
                    {{ scope.row[item.prop]}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="210"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.expressTypeName === '市内配送'"
                    class="btn-text"
                    type="text"
                    @click="openLocalDistribution(scope.row)"
                  >启运设置</el-button>
                  <el-button
                    v-else
                    :class="scope.row.type != 2?'btn-text':'btn-text-gray'"
                    type="text"
                    :disabled="scope.row.type == 2"
                    @click="setRules(scope.row)"
                  >运费设置</el-button>
                  <el-button
                    v-if="scope.row.expressTypeName === '市内配送'"
                    class="btn-text"
                    type="text"
                    @click="openCostSetting(scope.row)"
                  >成本设置</el-button>
                  <el-button
                    class="btn-red-text"
                    type="text"
                    @click="delService(scope.row.id)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <pagination-tpl
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @queryChange="queryChange"
              ></pagination-tpl>
            </div>
          </div>
          <div v-else class="nothing">
            <img class="nothing-img" src="../../../../../assets/images/nothing//warehous-nothing.png">
          </div>
        </div>
      </div>
    </div>

    <!-- 创建/编辑物流资源 -->
    <el-drawer
      class="save-logistics"
      :title="saveLogisticsTitle"
      :visible.sync="saveLogisticsDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseSaveLogisticsDrawer">
      <div class="el-drawer__body">
        <el-form ref="saveLogisticsForm" :model="saveLogisticsForm" :rules="rules">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="saveLogisticsForm.companyName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="header">
            <el-input v-model="saveLogisticsForm.header" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="saveLogisticsForm.phone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="快递类型" prop="type">
            <el-select
              v-model="saveLogisticsForm.type" 
              popper-class="multiple-checkbox" 
              multiple placeholder="请选择" 
              class="white" 
              :disabled="saveLogisticsTitle == '编辑'"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span class="checkbox"></span>
                <span class="label-name-box">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseSaveLogisticsDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirmSaveLogisticsForm('saveLogisticsForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 新增服务关系 -->
    <el-drawer
      class="save-logistics"
      title="新增服务关系"
      :visible.sync="addServiceDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseAddServiceDrawer">
      <div class="el-drawer__body">
        <el-form ref="addServiceForm" :model="addServiceForm" :rules="addServiceFormRules">
          <el-form-item label="物流公司" prop="companyName">
            <el-input v-model="addServiceForm.companyName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="快递类型" prop="expressType">
            <el-select
              v-model="addServiceForm.expressType" 
              placeholder="请选择" 
              class="white" 
            >
              <el-option
                v-for="item in expressTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库" prop="warehouseId">
            <el-select v-model="addServiceForm.warehouseId" placeholder="请选择" class="white">
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计费类型" prop="type">
            <el-select v-model="addServiceForm.type" placeholder="请选择" class="white">
              <el-option
                v-for="item in EXPRESS_TYPE_LIST"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成本系数" prop="costCoefficient" v-if="addServiceForm.type == 2">
            <el-input v-model="addServiceForm.costCoefficient" placeholder="请输入" @input="inputCostCoefficient(addServiceForm.costCoefficient)"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseAddServiceDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirmAddServiceForm('addServiceForm')">确定</el-button>
      </div>
    </el-drawer>
    
    <!-- 物流映射 -->
    <el-drawer
      class="mapping-drawer"
      title="物流映射"
      :visible.sync="mappingDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseMappingDrawer"
    >
      <div class="mapping-content">
        <el-form ref="mappingForm" :model="mappingForm">
          <p class="sub-title">创建映射</p>
          <el-form-item label="WMS快递名称" prop="name">
            <el-input v-model="mappingForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="快递类型" prop="type">
            <el-select v-model="mappingForm.type" filterable placeholder="请选择" class="white">
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-mapping" @click="matchingMapping">匹配映射</el-button>
          </el-form-item>
        </el-form>

        <div class="mapping-container">
          <el-collapse accordion>
            <el-collapse-item
              v-for="(item, index) in list"
              :key="index"
            >
              <template slot="title">
                <img class="arrow-right" src="../../../../../assets/images/arrow/arrow-right.png">
                <span>{{ item.name }}</span>
                <div class="num">
                  <span>（WMS快递共 </span>
                  <span class="hign-num">{{ item.data.length }} </span>
                  <span>个）</span>
                </div>
                <!-- <img v-if="item.isShowAdd" class="add-sign" src="../../../../../assets/images/system/add.png" /> -->
              </template>
              <div
                class="mapping-express"
                v-for="(item, index) in item.data"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <i class="el-icon-delete" @click="delMapping(item)"></i>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseMappingDrawer">取消</el-button>
      </div>
    </el-drawer>
    
    <!-- 启运设置 -->
    <el-drawer
      class="local-distribution-drawer"
      title="启运设置"
      :visible.sync="localDistributionDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseLocalDistributionDrawer"
    >
      <div class="local-distribution-content">
        <div class="local-distribution-list">
          <div class="search">
            <el-form ref="searchForm" :model="searchForm">
              <el-form-item prop="date" class="search-date">
                <el-date-picker
                  v-model="searchForm.date"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月份"
                ></el-date-picker>
              </el-form-item>
              <el-button icon="el-icon-search" class="btn-blue" @click="search">搜索</el-button>
            </el-form>
          </div>
          <div class="table">
            <el-table ref="table" :data="localDistributionData" style="width: 100%" :header-cell-class-name="headerCellClassName">
              <el-table-column
                v-for="(item, index) in localDistributionTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                show-overflow-tooltip
                :min-width="item.width"
                :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
              ></el-table-column>
            </el-table>
            <div class="pagination">
              <pagination-tpl
                :total="localDistributionTotal"
                :currentPage="localDistributionCurrentPage"
                :pageSize="localDistributionPageSize"
                @queryChange="localDistributionQueryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
        <div class="local-distribution-form">
          <div class="local-distribution-form-content">
            <p class="sub-title">设置</p>
            <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="entryFormRules">
              <el-form-item label="仓库" prop="warehouseId">
                <el-select 
                  class="white"
                  clearable
                  v-model="entryForm.warehouseId"
                  placeholder="请选择仓库"
                  disabled
                >
                  <el-option
                    v-for="item in warehouseList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="日期" prop="date">
                <el-date-picker
                  v-model="entryForm.date"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="当月成本" prop="monthCost">
                <el-input
                  v-model="entryForm.monthCost"
                  placeholder="请输入"
                  clearable
                  @input="monthCostInput(entryForm.monthCost)"
                ></el-input>
              </el-form-item>
              <el-form-item label="停运日期" prop="outageDate">
                <el-date-picker
                  v-model="entryForm.outageDate"
                  :picker-options="pickerOptions"
                  type="dates"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="local-distribution-form-footer">
            <el-button class="btn-gray" @click="handleCloseLocalDistributionDrawer">取消</el-button>
            <el-button class="btn-blue" @click="confirmAddLocalDistributionForm('entryForm')">确定</el-button>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 成本设置 -->
    <el-drawer
      class="cost-details-drawer"
      title="成本设置"
      :wrapperClosable="false"
      :visible.sync="costSettingDrawer"
      :before-close="handleCloseCostSettingDrawer"
    >
      <div class="drawer-content">
        <div class="drawer-container">
          <div class="cost-title">{{ costTitle }}</div>
          <div class="table">
            <el-table :data="costData">
              <el-table-column label="项目" prop="projectName"></el-table-column>
              <el-table-column
                label="分摊方式"
                prop="allocationMethod"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.allocationMethod" 
                    placeholder="请选择" 
                    class="white allocation-method"  
                  >
                    <el-option
                      v-for="item in allocationMethodList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="单价"
                prop="unitPrice"
              >
                <template slot-scope="scope">
                  <el-input
                    v-if="scope.row.allocationMethod == 1"
                    class="unit-price"
                    v-model="scope.row.unitPrice"
                    placeholder="请输入"
                    @input="costInput('unitPrice', scope.row.unitPrice, scope.row)"
                  >
                    <template slot="append">元/件</template>
                  </el-input>
                  <div v-else class="no-set">无法设置</div>
                </template>
              </el-table-column>
              <el-table-column
                label="比例"
                prop="proportion"
              >
                <template slot-scope="scope">
                  <el-input
                    v-if="scope.row.allocationMethod == 2"
                    class="proportion"
                    v-model="scope.row.proportion"
                    placeholder="请输入"
                    @input="costInput('proportion', scope.row.proportion, scope.row)"
                  >
                    <template slot="append">%</template>
                  </el-input>
                  <div v-else class="no-set">无法设置</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseCostSettingDrawer">取消</el-button>
        <el-button class="btn-blue" @click="saveCostSet">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Logistics from "models/logistics";
const logistics = new Logistics();
import Expenses from "models/expenses";
const expenses = new Expenses();
import ExpressInquiry from "models/express-inquiry";
const expressInquiry = new ExpressInquiry();
import LocalDistribution from "models/data-entry/local-distribution";
import PaginationTpl from "components/base/PaginationTpl";
import statusMixins from '@/common/mixins/status'
import expressMixins from '@/common/mixins/express'
import warehouseMixins from '@/common/mixins/warehouse'
import projectMixins from "@/common/mixins/project.js"
import { fuzzyQuery, formatTimeToYearAndMonth, inputAllTwoDecimal, numsToRMBSymbolAndMillimeter, getDecimal } from "@/common/js/util";
export default {
  mixins: [statusMixins, expressMixins, warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    const isTelephone = (mobileNumber) => {
      const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      return reg.test(mobileNumber);
    };
    const validateTelephone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        if (!isTelephone(value)) {
          callback(new Error("请输入有效手机号码"));
        }
        callback();
      }
    };
    return {
      activeIndex: null,
      searchCompanyName: '',
      companyId: null,
      // 用户编辑公司时
      modCompanyId: null,
      // 物流公司列表
      logisticsCompanyList: [],
      logisticsCompanyListCopy: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '仓库名称', prop: 'warehouseName', width: '', alignment:'left'},
        {label: '快递类型', prop: 'expressTypeName', width: '', alignment:'left'},
        {label: '计费类型', prop: 'typeVal', width: '', alignment:'left'},
        {label: '成本系数', prop: 'costCoefficient', width: '', alignment:'right'},
      ],

      saveLogisticsTitle: '',
      saveLogisticsDrawer: false,
      saveLogisticsForm: {
        companyName: '',
        header: '',
        phone: '',
        type: []
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        header: [
          { required: true, message: '请输入负责人', trigger: 'blur' },
        ],
        phone: [
          { required: true, validator: validateTelephone, trigger: "blur" }
        ],
        type: [
          { required: true, message: '请选择快递类型', trigger: 'change' },
        ],
      },

      addServiceDrawer: false,
      addServiceForm: {
        companyName: '',
        expressName: '',
        expressType: null,
        warehouseId: null,
        type: null,
        costCoefficient: 0,
      },
      expressTypeList: [],
      addServiceFormRules: {
        expressType: [
          { required: true, message: '请选择快递类型', trigger: 'change' },
        ],
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择计费类型', trigger: 'change' },
        ],
        costCoefficient: [
          { required: true, message: '请输入成本系数', trigger: 'blur' },
        ]
      },

      // 物流映射开关
      mappingDrawer: false,
      mappingForm: {
        name: '',
        type: null
      },
      list: [],

      // 启运设置开关
      localDistributionDrawer: false,
      localDistributionData: [],
      localDistributionTitleList: [
        {label: '日期', prop: 'createTime', width: '', alignment:'left'},
        {label: '仓库', prop: 'warehouseName', width: '', alignment:'left'},
        {label: '当月成本', prop: 'monthCost', width: '', alignment:'right'},
        {label: '停运日期', prop: 'outageDate', width: '', alignment:'left'},
        {label: '日均成本', prop: 'averageDailyCost', width: '', alignment:'right'}
      ],
      localDistributionTotal: 0,
      localDistributionCurrentPage: 1,
      localDistributionPageSize: 20,
      entryForm: {
        warehouseId: '',
        date: formatTimeToYearAndMonth(),
        monthCost: '',
        outageDate: '',
      },
      entryFormRules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        monthCost: [
          { required: true, message: '请输入当月成本', trigger: 'blur' }
        ],
        // outageDate: [
        //   { required: true, message: '请选择停运日期', trigger: 'change' }
        // ]
      },
      searchForm: {
        warehouseId: '',
        date: ''
      },
      //日期选择范围在一个月内
      pickerOptions: {
        // 限制日期
        disabledDate: this.disabledDate,
      },

      // 成本设置开关
      costSettingDrawer: false,
      costTitle: '',
      costWarehouseId: '',
      costData: [],
      allocationMethodList: [
        {id:1, name: '单价'},
        {id:2, name: '比例'}
      ]
    }
  },

  watch: {
    'entryForm.outageDate': {
      handler(newVal) {
        if (!this.entryForm.date && newVal) {
          this.entryForm.outageDate = ''
          this.$message({
            type: 'error',
            message: '请先选择日期'
          })
          return 
        }
      }
    }
  },

  created() {
    this.initExpressList()
    this.initWarehouse()
    this.initLogisticsCompanyList()
  },

  methods: {
    /** 
     * @desc 获取物流公司列表
    */
    initLogisticsCompanyList() {
      logistics.getLogisticsCompanyList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.header = i.contact
            obj.phone = i.phone
            obj.expressType = i.expressType
            obj.expressNameList = i.expressTypeList
            arr.push(obj)
          })
          this.logisticsCompanyList = arr
          this.logisticsCompanyListCopy = arr
          if (arr.length) this.selectLogistics(arr[0], 0)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /** 
     * @desc 服务关系列表
    */
    initSerachList() {
      let pageNo = this.currentPage
      let logisticCompanyId = this.companyId
      let data = {
        pageNo,
        logisticCompanyId
      }
      logistics.getSerachList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.expressTypeName = i.expressTypeName
            obj.expressType = i.expressType
            obj.type = i.expressMethod
            obj.typeVal = this.EXPRESS_TYPE[i.expressMethod]
            obj.costCoefficient = i.expressMethod == 2 ? i.costCoefficient:'/'
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 映射列表
    */
    initMappingList() {
      logistics.getMappingList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.expressType
            obj.name = i.expressTypeName
            obj.data = []
            i.expressNameList.map(j => {
              let obj2 = {}
              obj2.id = j.id
              obj2.name = j.expressName
              obj.data.push(obj2)
            })
            arr.push(obj)
          })
          this.list = arr
          this.mappingDrawer = true
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 市内配送列表
    */
    initList() {
      let currentPage = this.localDistributionCurrentPage
      let warehouseId = this.searchForm.warehouseId
      let date = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        date
      }

      LocalDistribution.getLocalDistributionList(data).then(res => {
        if (res.success) {
          let arr = []
          this.localDistributionTotal = res.result.totalNum
          this.localDistributionPageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.date
            obj.warehouseName = i.warehouseName
            obj.monthCost = numsToRMBSymbolAndMillimeter(i.monthCost)
            let outageDate = ''
            i.cityDeliveryOutageDateList.map(i => {
              outageDate += `；${i.substring(5)}`
            })
            obj.outageDate = outageDate.substring(1)
            obj.averageDailyCost = numsToRMBSymbolAndMillimeter(i.dayCost)
            arr.push(obj)
          })
          this.localDistributionData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    
    /** 
     * @desc 成本设置列表
    */
    initCostSetList(row) {
      LocalDistribution.getCostSettingDetails(row.warehouseId).then(async res => {
        if (res.success) {
          let arr = []
          if (res.result.length === 0) {
            await this.initAsyncProjectListByWarehouse(row.warehouseId);
            this.projectList.map(i => {
              let obj = {}
              obj.projectId = i.id
              obj.projectName = i.name
              obj.allocationMethod = 1
              obj.unitPrice = ''
              obj.proportion = ''
              arr.push(obj)
            })
          } else {
            res.result.map(i => {
              let obj = {}
              obj.projectId = i.projectId
              obj.projectName = i.projectName
              obj.allocationMethod = i.shareType
              obj.unitPrice = i.shareRule.unitPrice? i.shareRule.unitPrice: ''
              obj.proportion = i.shareRule.ratio? i.shareRule.ratio:''
              arr.push(obj)
            })
          }
          this.costData = arr
          this.costSettingDrawer = true
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 修改成本系数
    */
    blurCostCoefficient(row) {
      let data = {
        id: row.id,
        costCoefficient: row.costCoefficient?row.costCoefficient:0
      }
      logistics.postModCostCoefficient(data).then(res => {
        if (res.success) {
          this.$message.success('修改成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    disabledDate(time) {
      const oneDay = 24 * 3600 * 1000
      let date = new Date(this.entryForm.date)
      let selectDate = date.getTime() 
      let year = date.getFullYear() 
      let month = date.getMonth() 
      // 获取当月总天数
      let days = new Date(year, month+1, 0).getDate()
      let one = (days-1) * 24 * 3600 * 1000;
      const minTime = selectDate - oneDay;
      const maxTime = selectDate + one;
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return time.getTime() < minTime || time.getTime() > maxTime;;
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex === 2 || columnIndex === 4) {
        return 'right-align'
      }
    },

    serverHeaderCellClassName({ columnIndex}) {
      if (columnIndex === 3) {
        return 'right-align'
      }
    },

    /** 
     * @desc 搜索物流公司
    */
    searchCompanyNameFnc() {
      this.logisticsCompanyList = fuzzyQuery(this.logisticsCompanyListCopy, item => item.name.indexOf(this.searchCompanyName) !== -1)
      if (this.logisticsCompanyList.length) this.selectLogistics(this.logisticsCompanyList[0], 0)
    },

    /** 
     * @desc 选择物流公司
    */
    selectLogistics(row, index) {
      this.companyId = row.id
      this.activeIndex = index
      this.addServiceForm.companyName = row.name
      this.expressTypeList = row.expressNameList
      this.initSerachList()
    },

    addService() {
      this.addServiceDrawer = true
    },
    
    /**
     * @desc 删除服务关系
     */
    delService(id) {
      this.$confirm("删除后，该快递规则将失效，请确认", "删除", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        expressInquiry.postDelExpress(data).then(res => {
            if (res.success) {
              this.initSerachList();
            } else {
              this.$message.error(res.message)
            }
          })
      });
    },

    setRules(row) {
      let name = `${row.warehouseName}_${row.expressTypeName}运费设置`
      this.$router.push({
        path: `/system-settings/supplier-manage-index/supplier-logistics-index/supplier-express-rules/${name}`,
        query: {
          companyId: this.companyId,
          isFlag: 1,
          id: row.id,
          warehouseName: row.warehouseName,
          warehouseId: row.warehouseId,
          expressMethod: row.type,
          expressType: row.expressType,
          expressName: row.expressTypeName,
        }
      })
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initSerachList()
    },

    createCompany() {
      this.saveLogisticsTitle = '创建'
      this.saveLogisticsDrawer = true
    },

    handleCloseSaveLogisticsDrawer() {
      this.$refs['saveLogisticsForm'].resetFields();
      this.saveLogisticsDrawer = false
    },

    /** 
     * @desc 保存物流公司
    */
    confirmSaveLogisticsForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.modCompanyId
          let name = this.saveLogisticsForm.companyName
          let contact = this.saveLogisticsForm.header
          let phone = this.saveLogisticsForm.phone
          let expressType = this.saveLogisticsForm.type
          let data = {
            name,
            contact,
            phone
          }
          if (this.saveLogisticsTitle === '编辑') {
            data.id = id
            logistics
              .postModLogistics(data)
              .then(res => {
                if (res.success) {
                  this.initLogisticsCompanyList();
                  this.handleCloseSaveLogisticsDrawer()
                } else {
                  this.$message.error(res.message)
                }
              })
          } else {
            data.expressType = expressType
            logistics
              .postSaveLogistics(data)
              .then(res => {
                if (res.success) {
                  this.initLogisticsCompanyList();
                  this.handleCloseSaveLogisticsDrawer()
                } else {
                  this.$message.error(res.message)
                }
              })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * @desc 限制成本系数为大于0的两位小数
    */   
    inputCostCoefficient(v) {
      this.addServiceForm.costCoefficient = getDecimal(v);
    },

    inputTableCostCoefficient(v, row) {
      row.costCoefficient = getDecimal(v);
    },

    handleCloseAddServiceDrawer() {
      this.$refs['addServiceForm'].resetFields();
      this.addServiceDrawer = false
    },
    
    /** 
     * @desc 新增服务关系
    */
    confirmAddServiceForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let logisticCompanyId = this.companyId
          let warehouseId = this.addServiceForm.warehouseId
          let expressType = this.addServiceForm.expressType
          let expressMethod = this.addServiceForm.type
          let costCoefficient = this.addServiceForm.costCoefficient
          let data = {
            logisticCompanyId,
            expressMethod,
            warehouseId,
            expressType,
            costCoefficient
          }
          expenses.postAddBaseInfo(data).then(res => {
              if (res.success) {
                this.initSerachList();
                this.handleCloseAddServiceDrawer()
              } else {
                this.$message.error(res.message)
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command){
      return {
        'value': value,
        'command':command,
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.saveLogisticsTitle = '编辑'
          this.modCompanyId = command.value.id
          let arr = []
          command.value.expressNameList.map(i => {
            arr.push(i.id)
          })
          this.saveLogisticsForm.type = arr
          this.saveLogisticsForm.companyName = command.value.name
          this.saveLogisticsForm.header = command.value.header
          this.saveLogisticsForm.phone = command.value.phone
          this.saveLogisticsDrawer = true
        break;
      }
    },

    openMapping() {
      this.initMappingList()
    },

    handleCloseMappingDrawer() {
      this.mappingForm.name = ''
      this.mappingForm.type = null
      this.mappingDrawer = false
    },

    delMapping(row) {
      this.$confirm("删除后，该映射关系将失效，请确认", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id: row.id
        }
        logistics.postDelMappingList(data).then(res => {
          if (res.success) {
            this.initMappingList()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    matchingMapping() {
      let expressName = this.mappingForm.name
      let expressType = this.mappingForm.type
      let data = {
        expressName,
        expressType
      }
      logistics.postSaveMappingList(data).then(res => {
        if (res.success) {
          this.$message.success('匹配成功')
          this.initMappingList()
        } else {
          this.$message.error(res.message)
        }
      })
    },


    /** 
     * @desc 开启启运设置
    */
    openLocalDistribution(row) {
      this.searchForm.warehouseId = row.warehouseId
      this.entryForm.warehouseId = row.warehouseId
      this.initList()
      this.localDistributionDrawer = true
    },

    handleCloseLocalDistributionDrawer() {
      this.$refs['entryForm'].resetFields();
      this.localDistributionDrawer = false
    },

    /* 录入市内配送 */
    confirmAddLocalDistributionForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let date = this.entryForm.date
          let monthCost = Number(this.entryForm.monthCost)
          let outageDateList = this.entryForm.outageDate ? this.entryForm.outageDate : []
          let data = {
            warehouseId,
            date,
            monthCost,
            outageDateList
          }
          LocalDistribution.postEntryLocalDistribution(data).then(res => {
            if (res.success) {
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    localDistributionQueryChange(data) {
      this.localDistributionCurrentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.localDistributionCurrentPage = 1
      this.initList();
    },

    monthCostInput(v) {
      this.entryForm.monthCost = inputAllTwoDecimal(v);
    },

    /** 
     * @desc 市内配送开启成本设置
     * @param {*} row 
    */
    openCostSetting(row) {
      this.costTitle = row.warehouseName
      this.costWarehouseId = row.warehouseId
      this.initCostSetList(row)
    },

    handleCloseCostSettingDrawer() {
      this.costSettingDrawer = false
    },

    /** 
      * @description 限制金额
      * @param {string} key 字段名
      * @param {string} val 值
      * @param {*} row 
    */
    costInput(key, val, row) {
      row[key] = getDecimal(val);
    },

    /** 
     * @description 保存成本设置
    */
    saveCostSet() {
      let warehouseId = this.costWarehouseId
      let projectSettings = []
      let num = 0
      let isFlag = false
      this.costData.map(i => {
        let obj = {}
        obj.projectId = i.projectId
        obj.shareType = i.allocationMethod
        obj.shareRule = {}
        if (i.allocationMethod == 1) obj.shareRule.unitPrice = i.unitPrice
        if (i.allocationMethod == 2) {
          obj.shareRule.ratio = i.proportion
          isFlag = true
          num += Number(i.proportion)
        }
        projectSettings.push(obj)
      })
      if (num !== 100 && isFlag) return this.$message.error('成本分摊比例之和不为100%，无法保存')
      let data = {
        warehouseId,
        projectSettings
      }
      LocalDistribution.postSaveCostSetting(data).then(res => {
        if (res.success) {
          this.handleCloseCostSettingDrawer()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/system/logistics-list.scss';
</style>
